/* sst-mint-partners.js — set marquee speed from section setting */
(function () {
  document.querySelectorAll('[data-mints]').forEach(function (el) {
    if (el.getAttribute('data-slider') !== 'true') return;
    var track = el.querySelector('[data-mints-track]');
    if (!track) return;
    var speed = el.getAttribute('data-speed');
    if (speed) track.style.setProperty('--mints-speed', speed + 's');
  });
})();
